import _ from 'underscore';
import URI from 'urijs';
import { http } from '@bingads-webui/http-util';

const defaultOptions = {
  // Notification service will be used in header, the notification server is in CCUI
  // need set withCredentials true to resolve cross domain issue.
  xhrFields: {
    withCredentials: true,
  },
  // Add X-Requested-With header to identify the request is from ajax
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
};

function appendQuery(uri, options) {
  const param = _.isObject(options.params) ? options.params : {};
  return new URI(uri).addQuery(param).toString();
}

export class RestfulService {
  get(uri, options = {}) {
    return http.get(appendQuery(uri, options), _.extend({}, options, defaultOptions));
  }

  post(uri, attrs = {}, options = {}) {
    return http.post(appendQuery(uri, options), _.extend({}, options, defaultOptions, {
      data: attrs,
    }));
  }

  put(uri, attrs = {}, options = {}) {
    return http.put(appendQuery(uri, options), _.extend({}, options, defaultOptions, {
      data: attrs,
    }));
  }

  patch(uri, attrs = {}, options = {}) {
    return http.patch(appendQuery(uri, options), _.extend({}, options, defaultOptions, {
      data: attrs,
    }));
  }

  delete(uri, options = {}) {
    return http.delete(appendQuery(uri, options), _.extend({}, options, defaultOptions));
  }
}
